// extracted by mini-css-extract-plugin
module.exports = {"tablePagination":"DataTablePagination_tablePagination__1RQ_H"};